/**
 * Copyright (c) 2018-2019 Aleksey Melnikov, True Directive Company.
 * @link https://truedirective.com/
 * @license MIT
*/
import { Directive, ElementRef, Input, Output, HostListener, EventEmitter, Renderer2, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { InternationalizationService } from '../internationalization/internationalization.service';

import { Keys, KeyInfo } from '@true-directive/base';

import { MaskState } from '@true-directive/base';
import { MaskSettings } from '@true-directive/base';
import { MaskSectionAction, MaskResult } from '@true-directive/base';

import { NumberParserFormatter } from '@true-directive/base';
import { Locale } from '@true-directive/base';

@Directive({
    selector: '[true-mask-number]',
    host: {'(input)': 'input($event.target.value)', '(blur)': 'blur()'},
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => MaskNumberDirective),
        multi: true
      }]
})
export class MaskNumberDirective {

  _localeSubscription: any;

  private onChange = (_: any) => {};
  private onTouched = () => {};

  registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }

  blur() {
    // ÐÑÐ¸ÑÐ°ÐµÐ¼, ÐµÑÐ»Ð¸ ÑÐ¾ÑÐ¼Ð°Ñ Ð½ÐµÐ²ÐµÑÐµÐ½
    let value = NumberParserFormatter.parse(this._txtValue, this.format, this._separators);
    if (value === null || isNaN(value)) {
      this.setText('');
    } else {
      this.setText(NumberParserFormatter.format(value, this.format, this._separators));
    }
    this.onTouched();
  }

  private _undo: Array<MaskResult> = [];
  private _redo: Array<MaskResult> = [];

  // Ð¢ÐµÐºÑÑÐµÐµ ÑÐ¸ÑÐ»Ð¾Ð²Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ
  private _numValue: number = null;

  // Ð¢ÐµÐºÑÑÐµÐµ ÑÐµÐºÑÑÐ¾Ð²Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ
  protected _txtValue: string = '';

  // Ð¡Ð¼ÐµÐ½Ð° ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ñ
  @Output('ynStateChange')
  stateChange = new EventEmitter<MaskState>();

  // Ð¡Ð¾ÑÑÐ¾ÑÐ½Ð¸Ðµ Ð´Ð¸ÑÐµÐºÑÐ¸Ð²Ñ
  private _state: MaskState = null;

  public get state(): MaskState {
    return this._state;
  }

  public set state(v: MaskState) {
    if (this._state !== v) {
      this._state = v;
      this.stateChange.emit(this._state); // ÐÐ·Ð»ÑÑÐ°ÐµÐ¼ ÑÐ¾Ð±ÑÑÐ¸Ðµ
    }
  }

  // ÐÐ±Ð½Ð¾Ð²Ð»ÑÐµÐ¼ ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ðµ
  protected updateState() {
    if (this._numValue === null) {
      this.state = MaskState.EMPTY;           // ÐÑÑÑÐ¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ
    } else {
      if (isNaN(this._numValue)) {
        this.state = MaskState.TYPING;       // Ð¡ÑÐ¸ÑÐ°ÐµÐ¼, ÑÑÐ¾ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ Ð½Ðµ Ð·Ð°Ð²ÐµÑÑÐ¸Ð» Ð²Ð²Ð¾Ð´
      } else {
        this.state = MaskState.OK;
      }
    }
  }

  // Sending a value to model
  protected toModel() {
    // Retrieving value
    if (this._txtValue === '') {
      this._numValue = null;
    } else {
      this._numValue = NumberParserFormatter.parse(this._txtValue, this.format, this._separators);
    }

    // Sending to model
    this.onChange(this._numValue);
    // Updating the state
    this.updateState();
  }

  processAndroid(txt: any) {
    //
    let res = this.currentRes();

    // Ð¢ÐµÐ¾ÑÐµÑÐ¸ÑÐµÑÐºÐ¸ Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ ÐºÑÑÑÐ¾ÑÐ° Ñ Ð½Ð°Ñ ÐµÑÑÑ..
    let key: KeyInfo = Keys.whichKeyHasBeenPressed(this.last_res.newValue, txt,
        this.last_res.selStart, res.selStart, this.last_res.selLength);

    let selStart = this.last_res.selStart;
    let selEnd = this.last_res.selStart;

    // ÐÑÐ»Ð¸ ÑÐµÐºÑÑ Ð²Ð´ÑÑÐ³ ÑÑÑÑÑÑ
    if (this.last_res.newValue !== '' && txt.length <= 1) {

      if (txt === '') {
        key = new KeyInfo(Keys.DELETE);
      } else {
        key = new KeyInfo(0, txt);
      }

      selStart = 0;
      selEnd = this.last_res.newValue.length;
    }

    let r = this.processKey(
      {
        keyCode: -1,
        key: key.code,
        char: key.char,
        shiftKey: false,
        ctrlKey: false,
        target: { selectionStart: selStart, selectionEnd: selEnd },
        preventDefault: (_: any) => {}
      });

    if (!r) {
      this.setRes(this.last_res); // ÐÐµ Ð¿ÑÐ¸Ð½ÑÐ»Ð¸, Ð²ÐµÑÐ½ÑÐ»Ð¸ Ð²ÑÑ Ð½Ð°Ð·Ð°Ð´
    }

    // ÐÐ°ÑÐµÐ¼ ÑÑÐ¾ Ð·Ð´ÐµÑÑ?.. Ð Ð²Ð´ÑÑÐ³..
    this.android_behavior = false;
    return;
  }

  // ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ Ð²Ð½Ð¾ÑÐ¸Ñ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ. Parser: View --> Ctrl
  input(txt: any) {
    if (this.android_behavior) {
      this.processAndroid(txt);
      return;
    }
    // ÐÐ¾ÑÑÐ¾Ð¼Ñ Ð¿ÑÑÐ°ÐµÐ¼ÑÑ Ð¿ÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ ÑÐ¾ÑÐ¼Ð°Ñ Ðº Ð²Ð²ÐµÐ´ÐµÐ½Ð½Ð¾Ð¼Ñ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ.
    let value = NumberParserFormatter.parse(txt, this.format, this._separators);
    if (value === null) {
      this.setText('');
    } else {
      if (!isNaN(value)) {
        this.setText(NumberParserFormatter.format(value, this.format, this._separators), true);
      }
    }
  }

  // Formatter: Ctrl --> View
  writeValue(value: any) {

    this._numValue = value;
    let txt = '';
    if (value !== null) {
      txt = NumberParserFormatter.format(value, this.format, this._separators);
    }

    if (txt !== this._txtValue) {
      this.setText(txt, false);
    }

    // No need to send to model, because this processor is called on model change
    // but state still needs to be updated
    this.updateState();
  }

  private _separators: Array<string> = ['.', ','];
  private _format: string = '{1.2}';

  @Input('true-mask-number')
  public set format(f: string) {

    if (this._txtValue !== '' && this._format !== f) {
      // ÐÐ¾ ÑÐ»Ð¾Ð¶Ð½Ð¾Ð¼Ñ Ð¿ÑÑÐ¸
      let res = this.currentRes();
      this._format = f;

      let state = NumberParserFormatter.reformat(this._txtValue,
        this.format, this._separators,
        res.selStart, res.selStart + res.selLength,
        true // Convert to format
      );

      this.setRes(this.getRes(state.value, state.selStart, state.selEnd));

    } else {
      this._format = f;
    }
  }

  public get format(): string {
    if (this._format === 'currency') {
      return this.intl.locale.currency;
    }
    return this._format;
  }

  android_behavior: boolean = false;
  last_res: MaskResult;

  @HostListener('keydown', ['$event'])
  keyDown(e: any) {
    return this.processKey(e);
  }

  public processKey(e: any): boolean {

    if (e.keyCode === 229 || e.keyCode === 0 || e.keyCode === undefined) { // test: if (e.keyCode >= 0) ...
      // Android detected
      this.android_behavior = true;
      this.last_res = this.currentRes();
      return;
    }

    const c = Keys.keyChar(e);

    let selStart: number = e.target.selectionStart;
    let selEnd: number = e.target.selectionEnd;
    let s: string = this._txtValue;

    const state0: any = this.getRes(s, selStart, selEnd);

    if (Keys.isFunctional(e.keyCode)) {
      return true;
    }

    if (e.keyCode === Keys.TAB || e.keyCode === Keys.ESCAPE) {
      return true;
    }

    if (e.keyCode === Keys.HOME || e.keyCode === Keys.END) {
      return true;
    }

    if (e.shiftKey && (e.keyCode === Keys.DELETE || e.keyCode === Keys.INSERT)) {
      return true;
    }

    if (e.ctrlKey && e.keyCode === Keys.Z) {
      // UNDO
      let undoRes = this._undo.pop();
      if (undoRes) {
        this._redo.push(this.getRes(s, selStart, selEnd));
        this.setRes(undoRes);
      }
      e.preventDefault();
      return false;
    }

    if (e.ctrlKey && e.keyCode === Keys.Y) {
      // REDO
      let redoRes = this._redo.pop();
      if (redoRes) {
        this._undo.push(this.getRes(s, selStart, selEnd));
        this.setRes(redoRes);
      }
      e.preventDefault();
      return false;
    }

    if (e.ctrlKey) {
      return true;
    }

    if (selStart === 0 && selEnd === this._txtValue.length) {
      s = '';
      selStart = 0;
      selEnd = 0;
    }

    let leadToFormat = false;
    let applied = false;

    if (e.keyCode === Keys.BACKSPACE || e.keyCode === Keys.DELETE) {

      let canAccept = NumberParserFormatter.canAcceptKey(s, e.keyCode, c, this.format, this._separators, selStart, selEnd);

      if (selStart === selEnd) {
        // ÐÐ¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð¾
        if (e.keyCode === Keys.BACKSPACE && selStart > 0) {
          if (canAccept)
            s = s.substring(0, selStart - 1) + s.substring(selEnd);

          selStart--;
          selEnd--;
        }

        if (e.keyCode === Keys.DELETE) {
          if (canAccept)
            s = s.substring(0, selStart) + s.substring(selEnd + 1);
          else {
            selStart++;
            selEnd++;
          }
        }

        applied = true;
      }

      if (selStart < selEnd) {
        // ÐÑÐ´ÐµÐ»ÐµÐ½Ð¾ Ð¾Ð´Ð¸Ð½ Ð¸Ð»Ð¸ Ð±Ð¾Ð»ÐµÐµ ÑÐ¸Ð¼Ð²Ð¾Ð»Ð¾Ð²
        let fragmentToDelete = s.substring(selStart, selEnd);

        if (canAccept) {
          if (fragmentToDelete.indexOf(this._separators[0]) >= 0) {
            s = s.substring(0, selStart) + this._separators[0] + s.substring(selEnd);
          } else {
            s = s.substring(0, selStart) + s.substring(selEnd);
          }
        }

        selEnd = selStart;
        applied = true;
      }
    }

    if (c.length === 1) {
      s = s.substring(0, selStart) + s.substring(selEnd);

      if (NumberParserFormatter.canAcceptKey(s, e.keyCode, c, this.format, this._separators, selStart)) {

        s = s.substring(0, selStart) + c + s.substring(selStart);
        selStart++;
        selEnd = selStart;
        applied = true;

      } else {
        e.preventDefault();
        return false;
      }
    }

    if (applied) {
      // ÐÑÐ¸ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¸ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð²Ð½ÐµÑÐµÐ¼ Ð² ÑÑÑÐº undo
      if (s !== state0.newValue) {
        this._undo.push(state0);
        this._redo = [];
      }

      const state3 = NumberParserFormatter.reformat(s, this.format, this._separators, selStart, selEnd, leadToFormat);
      this.setRes(this.getRes(state3.value, state3.selStart, state3.selEnd));

      if (this.android_behavior) {
        return true;
      }

      e.preventDefault();
      return false;
    }

    return true;
  }

  // Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ð¸ Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ ÐºÑÑÑÐ¾ÑÐ°
  protected setRes(res: MaskResult) {

    if (this.android_behavior)
      res.selLength = 0;

    this.setText(res.newValue);
    this._renderer.setProperty(this._elementRef.nativeElement, 'selectionStart', res.selStart);
    this._renderer.setProperty(this._elementRef.nativeElement, 'selectionEnd', res.selStart + res.selLength);
  }

  protected currentRes() {
    let res = new MaskResult(this._txtValue, MaskSectionAction.APPLY, 0);
    res.selStart = this._elementRef.nativeElement.selectionStart;
    res.selLength = this._elementRef.nativeElement.selectionEnd - res.selStart;
    return res;
  }

  // ÐÐ¾Ð»ÑÑÐ¸ÑÑ ÑÐµÐºÑÑÐµÐµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ð¼Ð°ÑÐºÐ¸ Ð¸ Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ ÐºÑÑÑÐ¾ÑÐ°
  protected getRes(s: string, selStart: number, selEnd: number): MaskResult {
    let res = new MaskResult(s, MaskSectionAction.APPLY, 0);
    res.selStart = selStart;
    res.selLength = selEnd - selStart;
    return res;
  }

  // ÐÐ°Ð¿Ð¸ÑÑÐ²Ð°ÐµÑ ÑÐµÐºÑÑ Ð² ÐºÐ¾Ð½ÑÑÐ¾Ð»
  protected setText(displayedValue: string, toModel: boolean = true) {

    // ÐÑÐ¾Ð±ÑÐ°Ð¶Ð°ÐµÐ¼
    this._txtValue = displayedValue;
    this._renderer.setProperty(this._elementRef.nativeElement, 'value', this._txtValue);

    // ÐÑÐ¿ÑÐ°Ð²Ð»ÑÐµÐ¼ Ð² Ð¼Ð¾Ð´ÐµÐ»Ñ
    if (toModel) {
      this.toModel();
    }
  }

  setLocale(locale: Locale) {
    this._separators[0] = locale.separators[0];
    this._separators[1] = locale.separators[1];

    // Updating view
    this.writeValue(this._numValue);
  }

  ngOnDestroy() {
    // Unsubscribing
    this._localeSubscription.unsubscribe();
  }

  constructor(protected _renderer: Renderer2,
      protected _elementRef: ElementRef,
      protected intl: InternationalizationService) {
    // Format change can follow locale change
    this._localeSubscription = this.intl.onLocaleChanged.subscribe(locale => this.setLocale(locale));
  }
}
